// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ZOCH_","notes":"Notes_notes__2EYrk","note":"Notes_note__1MQc-","markdown":"Notes_markdown__1lanl"};